
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Histogram/index.md?watch=parent';
    export const demoIndex = {
  ids: ["histogram-demo-common","histogram-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Histogram" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Histogram/index.md?type=demo')
};